module.exports = __webpack_public_path__ + "img/gift2-hd-be.15621ca1.jpg";